// session.service.ts

class UserSessionService {
  private readonly USER_KEY = "loggedInUser";
  private readonly BUSINESS_KEY = "loggedInBusiness";

  // ==============================
  // User
  // ==============================

  get currentUser() {
    const data = localStorage.getItem(this.USER_KEY);
    return data ? JSON.parse(data) : null;
  }

  set currentUser(user: any) {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
  }

  clearUser() {
    localStorage.removeItem(this.USER_KEY);
  }

  // ==============================
  // Business
  // ==============================

  get currentBusiness() {
    const data = localStorage.getItem(this.BUSINESS_KEY);
    return data ? JSON.parse(data) : null;
  }

  set currentBusiness(business: any) {
    localStorage.setItem(this.BUSINESS_KEY, JSON.stringify(business));
  }

  clearBusiness() {
    localStorage.removeItem(this.BUSINESS_KEY);
  }

  // ==============================
  // Derived Getters (Safe)
  // ==============================

  get currentBusinessCategoryId(): string | null {
    return this.currentBusiness?.businessCategory?.[0]?.businessCategoryID ?? null;
  }

  get currentBusinessTypeId(): string | null {
    return this.currentBusiness?.businessType?.[0]?.businessTypeID ?? null;
  }

  get currentBusinessCategoryName(): string | null {
    return this.currentBusiness?.businessCategory?.[0]?.name ?? null;
  }

  get currentBusinessTypeName(): string | null {
    return this.currentBusiness?.businessType?.[0]?.name ?? null;
  }

  get currentBusinessName(): string | null {
    return this.currentBusiness?.businessName ?? null;
  }

  get currentBusinessId(): string | null {
    return this.currentBusiness?.id ?? null;
  }

  get isLoggedIn(): boolean {
    return !!this.currentUser;
  }

  get currentUserId(): string | null {
    return this.currentUser?.id ?? null;
  }

  get currentUserRoleName(): string | null {
    return this.currentUser?.personType?.[0]?.name ?? null;
  }

  get currentUserFullName(): string | null {
    const user = this.currentUser;

    if (!user?.firstName && !user?.lastName) {
      return null;
    }

    return [user.firstName, user.lastName]
      .filter(Boolean)
      .join(" ");
  }

  get currentUserRole(): string | null {
    return this.currentUser?.personType?.[0]?.name ?? null;
  }

  get currentUserMobileNumber(): string | null {
    return this.currentUser?.mobileNumber ?? null;
  }

  get currentUserToken(): string {
    const token = localStorage.getItem('token');
    return token ?? '';
  }

  get currentUserRefreshToken(): string {
    const refreshtoken = localStorage.getItem('refreshtoken');
    return refreshtoken ?? '';
  }

  // ==============================
  // Clear Entire Session
  // ==============================

  clearSession() {
    this.clearUser();
    this.clearBusiness();
  }
}

export const USER_SESSION_SERVICE = new UserSessionService();